import { render, staticRenderFns } from "./BoxRank.vue?vue&type=template&id=a60ce30a&scoped=true"
import script from "./BoxRank.vue?vue&type=script&lang=js"
export * from "./BoxRank.vue?vue&type=script&lang=js"
import style0 from "./BoxRank.vue?vue&type=style&index=0&id=a60ce30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60ce30a",
  null
  
)

export default component.exports